import { render, staticRenderFns } from "./GestioneUtenti.vue?vue&type=template&id=536674b1&"
import script from "./GestioneUtenti.ts?vue&type=script&lang=ts&"
export * from "./GestioneUtenti.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports